//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

// Joyride renders its tooltip into a portal beside the app, wrapped in an
// element of this class.
const TOOLTIP_CLASS = 'react-joyride__floater';

/** The selector for an element tagged with `data-joyride-id`. */
export const anchor = (id: string): string =>
  `[data-joyride-id="${CSS.escape(id)}"]`;

/**
 * The selector for an element by id. Escaped because a plugin surface's id
 * carries colons, which a bare `#id` selector reads as a pseudo-class and
 * throws on rather than missing.
 */
export const idSelector = (id: string): string => `#${CSS.escape(id)}`;

/**
 * Whether an event landed on the running tour's tooltip. Because the tooltip
 * is a portal, anything listening for a click away from the thing a step
 * points at -- a menu, a popper -- reads a click on the tooltip as a click
 * away, and closes the very thing the step is about.
 */
export const isWithinTourTooltip = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(`.${TOOLTIP_CLASS}`) !== null;
